import { render, staticRenderFns } from "./WBotsItem.vue?vue&type=template&id=737648c9&"
import script from "./WBotsItem.vue?vue&type=script&lang=js&"
export * from "./WBotsItem.vue?vue&type=script&lang=js&"
import style0 from "./WBotsItem.vue?vue&type=style&index=0&id=737648c9&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports